// extracted by mini-css-extract-plugin
export default {"TableView":"StockTable_TableView__bkS+y","Cell":"StockTable_Cell__e8O8X","Paper":"StockTable_Paper__C+aH4"};